<template>
  <div>
    <div class="overlay" @click="$emit('close')" />
    <div class="modal-content">
      <div class="container" style="width: 60%;">
        <h4>Company</h4>
        <p>Please enter basic information for the company.</p>
        <small><i>*required</i></small>
        <hr />
        <form v-on:submit.prevent>
          <div class="row">
            <div class="form-group col-md-6">
              <div class="form-group input-group">
                <span style="background: white;" class="input-group-addon"
                  ><span>Name*</span></span
                >
                <input
                  class="form-control"
                  v-model="name"
                  type="username"
                  placeholder="Provider Name"
                  required
                />
              </div>
            </div>

            <div class="form-group col-md-6">
              <div class="form-group input-group">
                <span style="background: white;" class="input-group-addon"
                  ><span>Year Founded*</span></span
                >
                <select
                  style="margin: 0px; border-top-left-radius: 0px;"
                  class="form-control"
                  v-model="year_founded"
                  required
                >
                  <option :value="null">Select year</option>
                  <option v-for="year in yearRange">{{ year }}</option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-12">
              <div class="form-group input-group">
                <span style="background: white;" class="input-group-addon"
                  ><span>URL*</span></span
                >
                <input
                  class="form-control"
                  v-model="url"
                  type="url"
                  oninvalid="setCustomValidity('Enter a valid URL beginning with http or https.')"
                  placeholder="https://example.com"
                  required
                />
              </div>
            </div>

            <div class="form-group col-md-12">
              <span>Description</span>
              <small><i>(200 - 1000 characters)</i></small>
              <div class="form-group input-group" style="width: 100%;">
                <textarea
                  style="border-radius: 5px;"
                  class="form-control"
                  v-model="description"
                  type="text"
                  rows="7"
                  maxlength="10000"
                  minlength="200"
                />
              </div>
            </div>

            <div class="form-group col-md-6">
              <div class="form-group input-group">
                <span style="background: white;" class="input-group-addon"
                  ><span>Email</span></span
                >
                <input
                  class="form-control"
                  v-model="email"
                  type="email"
                  placeholder="Email address"
                  required
                />
              </div>
            </div>

            <div class="form-group col-md-6">
              <div class="form-group input-group">
                <span style="background: white;" class="input-group-addon"
                  ><span>Phone Number</span></span
                >
                <input
                  class="form-control"
                  v-model="phone_number"
                  type="tel"
                  pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                  placeholder="Phone number"
                />
              </div>
            </div>
          </div>
        </form>
        <form v-on:submit.prevent="submitCompany">
          <button class="btn-create">Submit</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import utils from "../components/utils.js";

export default {
  data() {
    return {
      name: "",
      description: "",
      url: "",
      year_founded: "",
      phone_number: "",
      email: ""
    };
  },
  name: "new-company-modal",
  computed: {
    yearRange: function() {
      return utils.yearRange();
    }
  },
  methods: {
    submitCompany: function(item) {
      var token = this.$store.getters.token;
      this.$store.getters.api.company
        .create(token, {
          name: this.name,
          description: this.description,
          url: this.url,
          year_founded: this.year_founded,
          phone_number: this.phone_number,
          email: this.email
        })
        .then(r => {
          this.$store.dispatch("addMessage", {
            text: "Company posted.",
            type: "info",
            duration: 5000
          });
          var id = r.data.id;
          this.$store.dispatch("fetchCompanies").then(() => {
            this.$emit("close", id);
          });
        })
        .catch(e => {
          this.$store.dispatch("addMessage", {
            text: "There was a problem posting this company.",
            type: "error",
            duration: 5000
          });
        });
    }
  }
};
</script>

<style scoped>
.options {
  display: inline-block;
  margin-left: 10px;
}

.modal-content {
  /* position: absolute; */
  z-index: 1000;
  padding-top: 0px;
  /* left: -140px; */
  /* top: 28px; */
  background-color: #fefefe;
  margin: auto;
  padding: 0px;
  border: 1px solid #888;
  max-height: 80vh;
  overflow: scroll;
}

.modal-default-button {
  float: right;
}
.selected {
  color: lightgrey;
}

.dropbtn {
  cursor: pointer;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown:hover .dropbtn {
  background-color: lightgrey;
}

input[type="text"] {
  width: 200px;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 6px;
  margin-bottom: 16px;
  resize: vertical;
}

.overlay {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/elements/createCompanyModal.vue